import {Stack} from '@mui/material';
import {useState} from 'react';
import {TechnicalSupportTable} from './TechnicalSupportTable/TechnicalSupportTable';
import {TechnicalSupportIssueSidebar} from './TechnicalSupportIssueSidebar/TechnicalSupportIssueSidebar';

export const TechnicalSupport = () => {
    const [forceRefetch, setForceRefetch] = useState(0);
    const [selectedItemId, setSelectedItemId] = useState<string | null>(null);

    return (
        <Stack>
            <TechnicalSupportTable
                forceRefetch={forceRefetch}
                setSelectedItemId={setSelectedItemId}
            />
            {selectedItemId && (
                <TechnicalSupportIssueSidebar
                    setSelectedItemId={setSelectedItemId}
                    selectedItemId={selectedItemId}
                    setForceRefetch={setForceRefetch}
                />
            )}
        </Stack>
    );
};
